import React, { useCallback } from 'react';
import t from '~t';
import { Button, Icon } from '~ui';

export default function BookmarkEditFormImportant({
  item: { important },
  onChange,
  onSave,
}) {
  const onToggle = useCallback(
    (e) => {
      e.preventDefault();
      onChange({ important: !important });
      onSave();
    },
    [important],
  );

  return (
    <Button
      variant={important ? 'default' : 'outline'}
      onClick={onToggle}
      title={t.s('favorites')}
    >
      <Icon name={important ? 'like_active' : 'like_outline'} />
    </Button>
  );
}
